/**
 * useFormStyles — canonical shared styles for all flyout edit forms.
 * Import this in every form inside a GenericDrawer instead of defining
 * local styledInput / styledSelect / fieldLabel makeStyles blocks.
 *
 * Design tokens match AssetEditForm exactly:
 *   height 38px · borderRadius 7px · fontSize 13px · bg #FAFAFA
 *   border #E5E7EB · focus #163A64 · label 12px/500 #374151
 */
export { useAssetFormStyles as useFormStyles } from './useAssetFormStyles'
export { useAssetFormStyles as default } from './useAssetFormStyles'
